import React from "react";

const AnalyticsPageHeader = React.memo(({ theme, icon, title, subtitle }) => {
  return (
    <div className={`analytics-page-header theme-${theme}`}>
      <div className="page-icon">{icon}</div>
      <div>
        <h3>{title}</h3>
        <p>{subtitle}</p>
      </div>
    </div>
  );
});

export default AnalyticsPageHeader;
